import PropTypes from 'prop-types';

import { Box, Skeleton } from '@mui/material';
import { styled } from '@mui/material/styles';

import FormFieldComponent from '../../Forms/FormFieldComponent';
import TableComponent from '../../Table/TableComponent';

import { TABLE_ID } from '../../Table/constants';

import { STYLED_TEXT } from '../../Forms/fieldTypes';

const StyledSkeleton = styled((props) => (
  <Skeleton {...props} variant="rectangular" />
))(() => ({
  borderRadius: '1rem',
  height: '4rem',
}));

const TabSkeleton = () => (
  <Skeleton
    height="5rem"
    width="16rem"
    variant="rectangular"
    sx={{ borderRadius: '1rem 1rem 0 0', minWidth: '16rem' }}
  />
);

const TabsSkeleton = () => (
  <Box sx={{ margin: '2rem 0' }}>
    <Box sx={{ display: 'flex', gap: '0.8rem', overflow: 'hidden' }}>
      {Array.from({ length: 20 }).map((v, i) => (
        <TabSkeleton key={i} />
      ))}
    </Box>
    <Skeleton height="0.4rem" width="100%" variant="rectangular" />
  </Box>
);

const SearchSkeleton = () => (
  <Box sx={{ display: 'flex', gap: '1rem' }}>
    <StyledSkeleton sx={{ flexGrow: 1 }} />
    <StyledSkeleton width="10rem" />
  </Box>
);

const FiltersSkeleton = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
    <SearchSkeleton />
    <Box sx={{ display: 'flex', gap: '1rem', overflow: 'hidden' }}>
      {Array.from({ length: 3 }).map((v, i) => (
        <StyledSkeleton key={i} width="20rem" sx={{ minWidth: '20rem' }} />
      ))}
    </Box>
  </Box>
);

const RecordsInfoSkeleton = () => (
  <Box sx={{ margin: '0.8rem 0' }}>
    <Skeleton width="30%" />
  </Box>
);

export const TableSkeleton = ({ columnsLength = 5, entriesLength = 25 }) => {
  const columns = Array.from({ length: columnsLength }).map((v, i) => ({
    Header: <Skeleton />,
    id: `${i}`,
    sortable: false,
    accessor: () => <Skeleton />,
  }));

  const entries = Array.from({ length: entriesLength }).map(() => ({}));
  return (
    <TableComponent
      tableId={TABLE_ID.tableSkeletonPlaceholder}
      columns={columns}
      entries={entries}
    />
  );
};

TableSkeleton.propTypes = {
  columnsLength: PropTypes.number,
  entriesLength: PropTypes.number,
};

export const ModuleSkeleton = () => (
  <Box>
    <TabsSkeleton />
    <FiltersSkeleton />
    <RecordsInfoSkeleton />
    <TableSkeleton />
  </Box>
);

export const FormSkeleton = ({ fieldsLength = 7 }) => {
  const fields = Array.from({ length: fieldsLength }).map((v, i) => ({
    label: <Skeleton sx={{ width: '10rem' }} />,
    keyName: `loading_${i}`,
    fieldType: STYLED_TEXT,
    isLoading: true,
  }));
  return (
    <Box sx={{ maxWidth: '30rem' }}>
      {fields.map((field) => (
        <FormFieldComponent key={field.keyName} {...field} />
      ))}
    </Box>
  );
};

FormSkeleton.propTypes = {
  fieldsLength: PropTypes.number,
};
